"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _styled.default;
  }
});

var _styled = _interopRequireDefault(require("./styled"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/styles/styled/index.js
// module id = 6230
// module chunks = 0